import AppCommonModal from "@/components/AppCommonModal";
import AppImage from "@/components/AppImage";
import {CommonPrimaryBtn} from "@/components/CommonBtn";
import useLanguage from "@/hooks/useLanguage";


const DeskTopTipsModal = ({show, onCancel}) =>{
  const { t } = useLanguage();

  return <AppCommonModal width={561} onCancel={onCancel} show={show} title={""} >
    <div className={"w-full flex flex-col items-center"}>
      <AppImage className={"!w-[188px] !h-[152px] mx-auto"} src={"/images/install-app.png"}></AppImage>
      <div className={"flex flex-col items-start w-full mt-[25px]"}>
        <div className={"text-[#0D132C] font-bold text-[16px] "}>{t('desktop_tips_modal.title')}</div>
        <div className={"text-[#000000] font-400 leading-2 mt-[10px]"}>
          {t('desktop_tips_modal.description')}
        </div>
      </div>
      <CommonPrimaryBtn onClick={onCancel} className={"rounded-[25px] mt-[30px] h-[44px]"}>{t('desktop_tips_modal.button')}</CommonPrimaryBtn>
    </div>
  </AppCommonModal>;
};

export default DeskTopTipsModal;
